import React from "react";
import { IconSize, IconProps } from "../theme";

const Padlock: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M26 10H22V7C22 5.4087 21.3679 3.88258 20.2426 2.75736C19.1174 1.63214 17.5913 1 16 1C14.4087 1 12.8826 1.63214 11.7574 2.75736C10.6321 3.88258 10 5.4087 10 7V10H6C5.46957 10 4.96086 10.2107 4.58579 10.5858C4.21071 10.9609 4 11.4696 4 12V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V12C28 11.4696 27.7893 10.9609 27.4142 10.5858C27.0391 10.2107 26.5304 10 26 10ZM16 20.5C15.7033 20.5 15.4133 20.412 15.1666 20.2472C14.92 20.0824 14.7277 19.8481 14.6142 19.574C14.5006 19.2999 14.4709 18.9983 14.5288 18.7074C14.5867 18.4164 14.7296 18.1491 14.9393 17.9393C15.1491 17.7296 15.4164 17.5867 15.7074 17.5288C15.9983 17.4709 16.2999 17.5007 16.574 17.6142C16.8481 17.7277 17.0824 17.92 17.2472 18.1666C17.412 18.4133 17.5 18.7033 17.5 19C17.5 19.3978 17.342 19.7794 17.0607 20.0607C16.7794 20.342 16.3978 20.5 16 20.5ZM20 10H12V7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3C17.0609 3 18.0783 3.42143 18.8284 4.17157C19.5786 4.92172 20 5.93913 20 7V10Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Padlock;
